module.exports = __webpack_public_path__ + "img/confianza-logo.2f864608.svg";